import { Store } from "react-notifications-component";

export const showNotification = (
  title,
  message,
  type = "default",
  duration = 9000,
  position = "top-right"
) => {
  Store.addNotification({
    title: title || "Notification",
    message: message || "This is a notification",
    type: type, // 'success', 'danger', 'info', 'default', 'warning'
    insert: "top",
    container: position, // 'top-right', 'top-left', 'bottom-right', 'bottom-left'
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: duration,
      onScreen: true,
    },
  });
};
